import React, { useState, useEffect } from "react";
import { AnimatePresence, motion } from "framer-motion";
import "../../styles/Metric.css";

const metrics = [
  {
    value: "₹2.9L",
    text: "average monthly margin recovered per engagement",
  },
  {
    value: "5.8%",
    text: "average food & beverage cost reduction across all clients",
  },
  {
    value: "6 / 6",
    text: "clients recovered diagnostic fee within 4 weeks of first changes",
  },
  {
    value: "Week 1",
    text: "when every client first sees their real operational picture",
  },
];

const testimonials = [
  {
    quote:
      "For the first time in three years, I understood exactly what my restaurant was actually costing me. That clarity alone changed how I make every decision now.",
    name: "R.S.",
    role: "Founder · Deveras Restaurant, South Bengaluru · 80 covers",
  },
  {
    quote:
      "I was running four locations and I was the system. Now each location runs identically — and I’m planning to open four more without any fear.",
    name: "V.N.",
    role: "Founder · Daily Sushis, 4-Location QSR Chain · Bengaluru",
  },
  {
    quote:
      "Our food cost dropped 4.2% in eight weeks. But the bigger win was that I stopped firefighting. The systems hold — even when I’m not looking.",
    name: "M.P.",
    role: "Founder · Adda’s Cloud Kitchen, Whitefield",
  },
];
const MetricsTestimonials = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % testimonials.length);
    }, 4000); // change every 4 sec

    return () => clearInterval(interval);
  }, []);
  return (
    <section className="m-section">
      {/* Metrics */}
      <div className="metric-container">
        {metrics.map((item, index) => (
          <div key={index} className="metric-boxs">
            <h2>{item.value}</h2>
            <p>{item.text}</p>
          </div>
        ))}
      </div>

      {/* Testimonials */}
      <div className="testimonial-wrapper">
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          className="testimonial-card"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -40 }}
          transition={{ duration: 0.6 }}
        >
          <div className="stars">★★★★★</div>
          <p className="text">“{testimonials[index].quote}”</p>

      <div className="user-info">
        <div className="user-logo">
          {testimonials[index].name}
        </div>

        <div>
          <h4>{testimonials[index].name}</h4>
          <span>{testimonials[index].role}</span>
        </div>
      </div>
    </motion.div>
      </AnimatePresence>
    </div>




      <section className="case-study sections">
        <div className='client-type'>
          <div className="diagnostic-cta">
        
        
        {/* LEFT */}
        <div className="left">
          <span className="big">4 → 1</span>
        </div>

        {/* RIGHT */}
        <div className="right">
          <h2>
            Four operating systems unified into one — Daily Sushis, Bengaluru
          </h2>

          <p>
            All 4 locations now run identically. Founder reduced site visits from daily to 2× per week.
          </p>

          <p>
            Expansion to 8 locations confirmed.
          </p>
        </div>
        </div>

      </div>
    </section>
    </section>
    
  );
};

export default MetricsTestimonials;